module.exports = __webpack_public_path__ + "static/width-f06ebc543a0e268354f22b36a35d448a.svg";